import React from "react"
import styled from "styled-components"
import Image from "../../hooks/image"
import { Link } from "gatsby"

const Logo = () => {
  return (
    <Link to="/">
      <Image />
    </Link>
  )
}

export default Logo
